import React from "react";
import { Professional } from "../../../types";
import { Select } from "../../shared";

interface ReportsProfessionalSelectProps {
  professionals: Professional[];
  selectedProfessionalId: number | null;
  onSelectProfessional: (id: number) => void;
  loading: boolean;
}

export const ReportsProfessionalSelect: React.FC<ReportsProfessionalSelectProps> = ({
  professionals,
  selectedProfessionalId,
  onSelectProfessional,
  loading,
}) => (
  <div className="w-full sm:w-auto">
    <Select
      label=""
      value={selectedProfessionalId || ""}
      onChange={(value) =>
        onSelectProfessional(typeof value === "number" ? value : parseInt(value as string, 10))
      }
      options={professionals.map((p) => ({
        value: p.id,
        label: p.name,
        image: p.picture ?? null,
      }))}
      placeholder="Selecione um profissional"
      disabled={loading}
      className="min-w-[200px]"
    />
  </div>
);
